module.exports = __webpack_public_path__ + "static/media/credit.63ba856a.svg";